<template>
  <div class="blog-list mt-5">
    <app-loading :isFull="true" v-if="isLoading" />
    <div class="container">
      <div class="row">
        <div class="container-fluid">
          <div class="col-12">
            <header class="mb-3">
              <h2 class="font-18 text-right">لیست مقالات</h2>
            </header>
            <div class="shadow shadow-sm mb-5 bg-white">
              <b-table
                stacked="lg"
                striped
                :fields="fieldsItems"
                :items="posts"
                class="text-center"
              >
                <template v-slot:cell(title)="data">
                  <router-link  v-if="data.item.status !== 'pending'" :to="`/dashboard/blog/edit/${data.item.id}`">
                    {{data.item.title}}
                  </router-link>
                  <a href="" v-else>
                    {{data.item.title}}
                  </a>
                </template>
                <template v-slot:cell(status)="data">
                  {{data.item.status === 'publish' ? 'تایید شده'  : data.item.status === 'edit'  ? 'پیش نویس' : "در انتظار تایید"}}
                </template>
                <template v-slot:cell(action)="data" >
                  <div class="text-center" v-if="data.item.status !== 'pending'">
                    <!-- <button
                      @click.stop="remove(row)"
                      class="font-16 px-5 py-2 bttn-fill bttn bttn-danger"
                      v-ripple
                    >حذف</button> -->
                       <span data-balloon-pos="up" data-balloon="ویرایش">
                    <button
                      class="bttn-material-circle bttn-jelly bttn-md bttn-success text-center"
                      v-ripple
                      @click="edit(data)"
                    >
                      <i class="flaticon-content"></i>
                    </button>
                  </span>

                  </div>
                </template>
              </b-table>
            </div>
            <page-number :lengthList="lengthList" @callBack="callBack"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blog-list",
  data() {
    return {
      isLoading:true,
      fieldsItems: [
        { key: "title", label: "عنوان" },
        { key: "status", label: "وضعیت" },
        { key: "action", label: "عملیات" }
      ],
      lengthList:15,
      page:1
    };
  },
  computed: {
    posts() {
      return this.$store.state.dashboardBlog.posts;
    }
  },
  mounted() {
    this.getPosts(1);
  },
  methods: {
    async callBack(p) {
      this.isLoading = true;
      this.page = p;
      let res = await this.$store.dispatch("dashboardBlog/getMyPosts", {
        page: this.page
      });
      this.lengthList = res.posts.length;
      this.isLoading = false;
    },
    async getPosts(page) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardBlog/getMyPosts", { page });
      this.isLoading = false;
    },
    async remove({ item, index }) {
      let result = window.confirm("آیا از حذف این مقاله مطمئن هستید؟");
      if (!result) return;
      this.isLoading = true;
      await this.$store.dispatch("dashboardBlog/remove", { id: item.id });
      this.$delete(this.posts, index);
      this.isLoading = false;
    },
    async edit({ item, index }) {
      this.$router.push(`/dashboard/blog/edit/${item.id}`)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dashboard/blog/index.vue